/**
 * GroupTable Component
 * 공통코드 그룹 테이블
 */
import React from 'react';
import { CommonCodeGroup, CommonCodeItem } from '../types/systemCommonCode.types';
import GroupRow from './GroupRow';
import { GROUP_TABLE_HEADERS, EMPTY_MESSAGES } from './commonCodeManagement.helpers';

// ======== 타입 ========

interface GroupTableProps {
    groups: CommonCodeGroup[];
    expandedGroupCodes: Set<string>;
    groupCodesCache: Record<string, CommonCodeItem[]>;
    groupCodesLoading: Record<string, boolean>;
    onToggleGroup: (grpCode: string) => void;
}

// ======== 컴포넌트 ========

const GroupTable: React.FC<GroupTableProps> = ({
                                                   groups,
                                                   expandedGroupCodes,
                                                   groupCodesCache,
                                                   groupCodesLoading,
                                                   onToggleGroup,
                                               }) => {
    return (
        <div className="table-wrapper">
            <table className="code-table">
                <thead>
                <tr>
                    {GROUP_TABLE_HEADERS.map((header, index) => (
                        <th key={index}>{header}</th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {groups.length === 0 ? (
                    <tr>
                        <td colSpan={GROUP_TABLE_HEADERS.length} className="empty-row">
                            {EMPTY_MESSAGES.NO_GROUPS}
                        </td>
                    </tr>
                ) : (
                    groups.map((group) => (
                        <GroupRow
                            key={group.grpCode}
                            group={group}
                            isExpanded={expandedGroupCodes.has(group.grpCode)}
                            isLoading={groupCodesLoading[group.grpCode] || false}
                            codes={groupCodesCache[group.grpCode] || []}
                            onToggle={onToggleGroup}
                        />
                    ))
                )}
                </tbody>
            </table>
        </div>
    );
};

export default GroupTable;
